import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = "https://finnmikoschek.de";

function normalizePath(pathname) {
  // canonical ohne trailing slash (außer root)
  if (pathname === "/") return "/";
  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
}

export default function Seo({
  title,
  description,
  canonicalPath, // optional: wenn du explizit setzen willst
  noindex = false,
}) {
  const { pathname } = useLocation();
  const path = canonicalPath ?? normalizePath(pathname);
  const canonical = `${SITE}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
      <link rel="canonical" href={canonical} />
      <meta
        name="robots"
        content={noindex ? "noindex,nofollow" : "index,follow"}
      />
    </Helmet>
  );
}
